var _path, _rect, _rect2, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 123,
    viewBox: "0 0 112 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 37H110V45C110 47.7614 107.761 50 105 50H7C4.23858 50 2 47.7614 2 45V37Z",
    stroke: "#6ECDA9",
    strokeWidth: 4
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 50,
    width: 11,
    height: 15,
    stroke: "#6ECDA9",
    strokeWidth: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 67,
    y: 50,
    width: 11,
    height: 15,
    stroke: "#6ECDA9",
    strokeWidth: 4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 94,
    r: 21,
    stroke: "#6ECDA9",
    strokeWidth: 4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 98,
    r: 5,
    stroke: "#6ECDA9",
    strokeWidth: 4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 78L56 93",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56 103L56 107",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 65.5L10 84.5V121",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85 65L102.5 84V121",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28 65H85",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 121L102 121",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M53.103 24.3218L56.9488 36.3399C56.9784 36.4324 57.0703 36.4903 57.1666 36.477L71.3145 34.5256C71.4189 34.5112 71.4942 34.4183 71.4867 34.3132L71.0109 27.6528C71.0045 27.5627 70.9383 27.488 70.8496 27.4708L53.3316 24.0645C53.1824 24.0355 53.0566 24.177 53.103 24.3218Z",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M85 27L87 27",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5338 2.14118L66.3111 3.43812L69.8003 9.46496L45.0405 13.2419L42.5338 2.14118Z",
    stroke: "#6ECDA9",
    strokeWidth: 4
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5 14.5C77.6683 23.0817 76.9844 26.8998 78 35.5",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M99 36.5C100.693 34.5227 101.519 33.2738 102.466 30.5977C102.487 30.537 102.477 30.4676 102.44 30.4149C84.9682 5.54456 56.7106 4.68435 29.1544 24.8866C29.0686 24.9495 28.9453 24.9334 28.8775 24.8515C22.8798 17.6099 18.4958 16.386 9.38917 18.8915C9.23029 18.9352 9.18946 19.145 9.31982 19.2458C15.8692 24.3101 17.7898 27.7895 16 35.5",
    stroke: "#6ECDA9",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg5);
export default __webpack_public_path__ + "static/media/5.f6afa3ad8ce8e2d2e4ee2eb8a4818c4d.svg";
export { ForwardRef as ReactComponent };